
import './Settings.css';

function Settings() {
    return (
        <div className="settings">

        </div>
    )
}

export default Settings;